export const FORM_COOKIE_KEY = 'conf-form';
export const NINETEEN_HUNDRED = 1900;
export const M = 'M';
export const N = 'N';

export class TipoDocumento {
    static readonly INFORMATIVA_PRIVACY = 'PRIVACY';
    static readonly RILEVAZIONE = 'RIL';
    static readonly RILEVAZIONE_ESTRATTO = 'RIL-ESTRATTO';
    static readonly NOTIFICA_DIFFIDA = 'NOTIFICA_DIFFIDA';
    static readonly DIFFIDA_CONTATTO = 'DIFFIDA_CONTATTO';
    static readonly ACCERTAMENTO = 'ACC';
    static readonly ACCERTAMENTO_ESTRATTO = 'ACC-ESTRATTO';
    static readonly SCHEDA_SETTORE_AGRICOLE = 'SCHEDA_SETTORE_AGRICOLE';
    static readonly SCHEDA_SETTORE_ALTRE = 'SCHEDA_SETTORE_ALTRE';
    static readonly SCHEDA_SETTORE_CONSUMO = 'SCHEDA_SETTORE_CONSUMO';
    static readonly SCHEDA_SETTORE_DETTAGLIANTI = 'SCHEDA_SETTORE_DETTAGLIANTI';
    static readonly SCHEDA_SETTORE_EDILIZIE = 'SCHEDA_SETTORE_EDILIZIE';
    static readonly SCHEDA_SETTORE_FIDI = 'SCHEDA_SETTORE_FIDI';
    static readonly SCHEDA_SETTORE_PRODUZIONE_LAVORO = 'SCHEDA_SETTORE_PRODUZIONE_LAVORO';
    static readonly SCHEDA_SETTORE_PESCA = 'SCHEDA_SETTORE_PESCA';
    static readonly SCHEDA_SETTORE_SOCIALI = 'SCHEDA_SETTORE_SOCIALI';
    static readonly SCHEDA_SETTORE_TRASPORTO = 'SCHEDA_SETTORE_TRASPORTO';
}
